package com.example.socialmediaapp.ui.theme

import androidx.compose.material3.darkColorScheme
import androidx.compose.ui.graphics.Color

object AppColors {
    // Legacy (kept for compatibility)
    val Primary = Color(0xFFE1306C)
    val Background = Color(0xFF18191A)
    val Surface = Color(0xFF242526)
    val SurfaceVariant = Color(0xFF3A3B3C)
    val OnBackground = Color(0xFFE4E6EB)
    val OnSurface = Color(0xFFE4E6EB)
    val OnSurfaceVariant = Color(0xFFB0B3B8)
    val Divider = Color(0xFF3E4042)
    val Error = Color(0xFFF02849)
    val LikeBlue = Color(0xFFE1306C)
    val LoveRed = Color(0xFFF02849)

    // Gradient brand colors (Purple/Hot-Green/Aqua inspired)
    val Purple = Color(0xFF9C27B0)
    val HotGreen = Color(0xFF00FF00)
    val Aqua = Color(0xFF00FFFF)

    val GradientStart = Purple
    val GradientMid = HotGreen
    val GradientEnd = Aqua
    val GradientAccent = Color(0xFF7C4DFF)
}

val AppDarkColorScheme = darkColorScheme(
    primary = AppColors.GradientStart,
    background = AppColors.Background,
    surface = AppColors.Surface,
    surfaceVariant = AppColors.SurfaceVariant,
    onBackground = AppColors.OnBackground,
    onSurface = AppColors.OnSurface,
    onSurfaceVariant = AppColors.OnSurfaceVariant,
    error = AppColors.Error
)
